import { useEffect, useRef } from 'react';
import OneSignal from 'react-onesignal';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const OneSignalButton = (props) => {

    const windowSize = useWindowSize();
    const originalRightRef = useRef(null);
    const originalBottomRef = useRef(null);
    const scrollToTopRef = useRef(null);

    useEffect(function oneSignalInit() {     
        OneSignal.init({ appId: props.siteSetting }).then(() => {
            OneSignal.setDefaultNotificationUrl(props.siteURL);

            OneSignal.on("subscriptionChange", function (isSubscribed) {
                if (isSubscribed) {
                    OneSignal.sendTags({
                        InternalContactCRMID: props.internalContactCRMID,
                        CentralUserAuthID: props.centralUserAuthID
                    });
                }
                adjustPosition();
            });
        })
    }, []);

    useEffect(() => {

        adjustPosition();

        const observer = new MutationObserver(adjustPosition);
        observer.observe(document.body, { childList: true, subtree: true });

        return () => {
            observer.disconnect();
        };
    }, [windowSize.width]);

    const adjustPosition = () => {
        let oneSignalBellLauncher = document.getElementById('onesignal-bell-launcher');
        if (oneSignalBellLauncher) {
            scrollToTopRef.current = document.getElementsByClassName('scrollToTop')[0];
            let hasListingControlBar = document.getElementsByClassName('mobile-listing-control-bar').length > 0;
            let hasMobileOptionBar = document.getElementsByClassName('mobile-option-bar').length > 0;
            let hasDetailsContactBar = document.getElementsByClassName('detail-contact-bar').length > 0;
            let isSubscribed = document.getElementsByClassName('onesignal-bell-launcher-sm')[0];
            let hasIntercom = document.getElementsByClassName('intercom-launcher').length > 0;

            if (!hasIntercom && window.Intercom) {
                hasIntercom = window.Intercom.booted;
            }

            if (originalRightRef.current === null) {
                originalRightRef.current = oneSignalBellLauncher.style.right
            }
            if (originalBottomRef.current === null) {
                originalBottomRef.current = oneSignalBellLauncher.style.bottom
            }

            oneSignalBellLauncher.style.right = originalRightRef.current;
            oneSignalBellLauncher.style.bottom = originalBottomRef.current;

            // Set style if intercom button is present or if "Scroll To Top" button is on the right of the screen
            if (hasIntercom || (scrollToTopRef.current && window.getComputedStyle(scrollToTopRef.current).right === '25px')) {
                oneSignalBellLauncher.style.bottom = isSubscribed ? '28px' : '20px';
                oneSignalBellLauncher.style.right = '85px';
            }

            if (hasMobileOptionBar || hasDetailsContactBar) {
                oneSignalBellLauncher.style.bottom = isSubscribed ? '83px' : '75px';
            }
            else if (isSubscribed) {
                oneSignalBellLauncher.style.bottom = '28px';
            }

            if (hasListingControlBar && windowSize.width < 775) {
                const listingControlBar = document.getElementsByClassName('mobile-listing-control-bar')[0].getBoundingClientRect();

                if (listingControlBar.height > 60) {
                    oneSignalBellLauncher.style.bottom = isSubscribed ? '97px' : '89px';
                }
                else {
                    oneSignalBellLauncher.style.bottom = isSubscribed ? '64px' : '56px';
                }

                const oneSignalRect = oneSignalBellLauncher.getBoundingClientRect();
                if (listingControlBar.top < oneSignalRect.bottom) {
                    oneSignalBellLauncher.style.bottom = isSubscribed ? '28px' : '20px';
                }
            }
        }

    };


    return <></>;
};

const toggleOneSignal = (show) => {
    let oneSignalBellLauncher = document.getElementById('onesignal-bell-launcher');
    if (oneSignalBellLauncher) {
        oneSignalBellLauncher.style.display = (show ? 'block' : 'none');
    }
}

export default OneSignalButton;
export { toggleOneSignal };